const PriceFilter = () => {
  return <h1>PriceFilter</h1>;
};

export { PriceFilter };
